/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamPatchRequestSchema } from './teamPatchRequestSchema';

export const teamBulkPatchItemRequestSchema = z.object({
  id: z.int(),
  get patch() {
    return teamPatchRequestSchema;
  },
});
